import axios from '../lib/axios'
import Bugsnag from './Bugsnag'
import AuthenticationService from './AuthenticationService'
import Store from '../store/Store'

const url = process.env.ZLICK_V2

export default {
  search: ({ searchQuery, page, limit }) => {
    if (!AuthenticationService.isInRole(['techsupport'])) throw new Error('Permission denied. Cannot search webhook logs')
    return axios.get(url + '/webhookLogs/findByQuery', {
      params: {
        search: searchQuery ? searchQuery.searchValue : undefined,
        startDate: searchQuery ? searchQuery.dates.startDate : undefined,
        endDate: searchQuery ? searchQuery.dates.endDate : undefined,
        page: page,
        limit: limit
      },
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
      .catch((error) => {
        Bugsnag.send(error)
        throw new Error('Failed to query webhookLogs ' + error)
      })
  },

  updateState: ({ webhookLogsId }) => {
    if (!AuthenticationService.isInRole(['techsupport'])) throw new Error('Permission denied. Cannot update webhook log\'s state')
    return axios.put(url + '/webhookLogs/' + webhookLogsId, { }, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      }
    })
      .catch((error) => {
        Bugsnag.send(error)
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/WebhookLogsService.js